import { Tabs, TabsList, TabsTrigger } from "@aurumiq/ui/components/tabs";
import { useSearchParams } from "react-router";
import { PageHeader } from "@/app/page-header";
import { EventsTab } from "@/features/billing/events-tab";
import { PlansTab } from "@/features/billing/plans-tab";
import { SubscriptionsTab } from "@/features/billing/subscriptions-tab";

const TABS = [
  ["plans", "Plans"],
  ["subscriptions", "Subscriptions"],
  ["events", "Webhook events"],
] as const;
type TabKey = (typeof TABS)[number][0];

export function BillingPage() {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get("tab");
  const tab: TabKey = TABS.some(([k]) => k === raw) ? (raw as TabKey) : "plans";
  return (
    <>
      <PageHeader
        title="Billing"
        description="Plans mirrored to Stripe, every organisation's subscription and the webhook log."
      />
      <Tabs
        value={tab}
        onValueChange={(v) => setSp(v === "plans" ? {} : { tab: v })}
        className="mb-4"
      >
        <TabsList>
          {TABS.map(([k, label]) => (
            <TabsTrigger key={k} value={k}>
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      {tab === "plans" ? (
        <PlansTab />
      ) : tab === "subscriptions" ? (
        <SubscriptionsTab />
      ) : (
        <EventsTab />
      )}
    </>
  );
}
